import React,{useEffect,useState} from 'react'
import InputBar from '../InputBar/InputBar'
import './Container.css'
import InputContainer from '../InputContianer/InputContainer'
import Footer from '../Footer/Footer'
import PlanComponent from '../PlanComponent/PlanComponent'
import AddOns from '../AddOns/AddOns'
import Summary from '../Summary/Summary'
import ThankYou from '../ThankYou/ThankYou'
import { useSelector} from 'react-redux'


const Container = () => {
  const currentStep = useSelector((state) => state.step)

  const renderComponent = () => {
    switch (currentStep) {
      case 1:
        return <InputContainer />
      case 2:
        return <PlanComponent />
      case 3:
        return <AddOns />
      case 4:
        return <Summary />
      case 5:
        return <ThankYou />
      default:
        return <InputContainer />
    }
  }

  return (
    <div className="Container">
      {renderComponent()}
      <Footer />
    </div>
  )
}


export default Container